import script from "./ServiceRelatedComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceRelatedComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServiceRelatedComponent.vue?vue&type=style&index=0&id=c1417978&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1417978"]])

export default __exports__